import Icon from "@mdi/react";
import { CircularProgress, Fab, FabProps } from "@mui/material";
import useBoundStore from "store";

export interface FABProps extends Omit<FabProps, "children"> {
  icon: string;
  loading?: boolean;
  title: string;
}

function FAB(props: FABProps) {
  const { className, color = "primary", icon, loading, title, ...others } = props;
  const isMobileDevice = useBoundStore((state) => state.miscellaneous.isMobileDevice);

  return (
    <Fab
      color={color}
      className={className}
      id='fab-button'
      sx={{
        position: isMobileDevice ? "fixed" : "absolute",
        bottom: "1rem",
        right: "1rem",
        zIndex: 1,
      }}
      {...others}
    >
      {loading ? <CircularProgress style={{ color: "white" }} /> : <Icon path={icon} title={title} size={1} />}
    </Fab>
  );
}

export default FAB;
